import React, { useEffect } from 'react';
import { useScript } from '../../../hooks/useScript';

declare global {
    interface Window {
        msPlayer: (options: { root: string; widgetId: string }) => void;
    }
}

export interface StoriesPlayerProps {
    rootId: string;
    widgetId: string;
    widgetContainer: string;
}

const StoriesPlayer = ({
    rootId,
    widgetId,
    widgetContainer,
}: StoriesPlayerProps) => {
    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const link = document.createElement('link');
        link.href = 'https://cdn.ampproject.org/amp-story-player-v0.css';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    const statusAmp = useScript(
        'https://cdn.ampproject.org/amp-story-player-v0.js',
        {
            async: true,
            removeOnUnmount: true,
        },
    );

    const status = useScript(
        'https://js.makestories.io/player/StoryPlayer.js',
        {
            removeOnUnmount: true,
        },
    );

    useEffect(() => {
        if (
            status === 'ready' &&
            statusAmp === 'ready' &&
            typeof window !== 'undefined'
        ) {
            window.msPlayer({
                root: `#${rootId}`,
                widgetId: widgetId,
            });
        }
    }, [status, statusAmp, widgetId, rootId]);

    return (
        <div
            dangerouslySetInnerHTML={{
                __html: widgetContainer,
            }}
        />
    );
};

export default StoriesPlayer;
